import {
  DATATABLE_UPDATE_COLUMNS_TABLE,
  DATATABLE_UPDATE_COLUMNS_TABLE_CURRICULUM,
  DATATABLE_UPDATE_ROWS_PER_PAGE,
  DATATABLE_UPDATE_SKIP
} from '../actions/datatable.actions'

const rowsPerPage = 50
const defaultData = {
  skip: 0,
  rowsPerPage,
  columnsTable: []
}

const initState = {
  curriculum: {
    columnsTable: [
      {
        label: 'Code',
        hide: true,
        key: 'shortName',
        show: true,
        delete: true,
        filter: 'text'
      },
      {
        label: 'Name',
        hide: true,
        key: 'name',
        show: true,
        delete: true,
        filter: 'text'
      }
    ]
  },
  user: {
    skip: 0,
    rowsPerPage,
    columnsTable: [
      {
        label: 'Photo',
        hide: true,
        key: 'avatar',
        align: 'center',
        className: 'text-center box-center',
        show: false
      },
      {
        label: 'Code',
        hide: true,
        key: 'code',
        show: true,
        delete: true,
        filter: 'text'
      },
      {
        label: 'First Name',
        hide: true,
        key: 'firstName',
        show: true,
        delete: true,
        filter: 'text'
      },
      {
        label: 'Last Name',
        hide: true,
        key: 'lastName',
        show: true,
        delete: true,
        filter: 'text'
      },
      {
        label: 'Preferred Name',
        hide: true,
        key: 'preferredName',
        show: false,
        delete: true,
        filter: 'text'
      },
      {
        label: 'Roles',
        hide: true,
        key: 'roles',
        show: true,
        delete: true,
        filter: 'roles'
      },
      {
        label: 'Date of birth',
        hide: true,
        key: 'bday',
        show: false,
        delete: true,
        filter: 'date'
      },
      {
        label: 'Email',
        hide: true,
        key: 'email',
        show: true,
        delete: true,
        filter: 'text'
      },
      {
        label: 'Year Level',
        hide: true,
        key: 'yearLevelUser',
        show: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'Activated',
        hide: true,
        key: 'activated',
        show: true,
        delete: true,
        align: 'center',
        filter: 'yes/no'
      },
      {
        label: 'Last Invited',
        hide: true,
        key: 'lastInvited',
        show: true,
        delete: true,
        align: 'center',
        filter: 'yes/no',
        filterLabel: 'Invited'
      },
      {
        label: 'Last login',
        hide: true,
        key: 'lastLogin',
        show: true,
        delete: true,
        align: 'center',
        filter: 'date'
      },
      {
        label: 'Flag',
        hide: true,
        key: 'flag',
        show: false,
        delete: true,
        filter: 'flag'
      }
    ]
  },
  lc: defaultData,
  dr: defaultData,
  ul: defaultData,
  subject: defaultData,
  class: defaultData,
  audit: {
    skip: 0,
    rowsPerPage: 100,
    columnsTable: [
      {
        label: 'Date',
        hide: true,
        key: 'date',
        show: true,
        width: 150,
        filter: 'dateRange'
      },
      { label: 'IP', hide: true, key: 'ip', show: true },
      {
        label: 'Module',
        hide: true,
        key: 'module',
        show: true,
        className: 'capitalize',
        filter: 'module'
      },
      {
        label: 'Action',
        hide: true,
        key: 'action',
        show: true,
        className: 'capitalize',
        filter: 'action'
      },
      {
        label: 'User',
        hide: true,
        key: 'user',
        show: true,
        width: 150,
        filter: 'userAudit'
      },
      {
        label: 'Roles',
        hide: true,
        key: 'roles',
        show: true,
        delete: true,
        filter: 'rolesAudit'
      }
    ]
  },
  maintenance: {
    skip: 0,
    rowsPerPage: 100,
    columnsTable: [
      {
        label: 'Date',
        hide: true,
        key: 'date',
        show: true,
        width: 150,
        filter: 'dateRange'
      },
      {
        label: 'Status',
        hide: true,
        key: 'status',
        show: true,
        width: 150,
        filter: 'status'
      },
      { label: 'IP', hide: true, key: 'ip', show: true },
      {
        label: 'Module',
        hide: true,
        key: 'module',
        show: true,
        className: 'capitalize',
        filter: 'module'
      },
      {
        label: 'Action',
        hide: true,
        key: 'action',
        show: true,
        className: 'capitalize',
        filter: 'action'
      },
      {
        label: 'User',
        hide: true,
        key: 'user',
        show: true,
        width: 150,
        filter: 'userAudit'
      }
    ]
  },
  roles: {
    rowsPerPage,
    columnsTable: [
      { label: 'Name', hide: true, key: 'name', show: true },
      {
        label: 'Module',
        hide: true,
        key: 'moduleName',
        show: true,
        className: 'text-center box-center color-secondary-blue text-bold',
        width: 200
      },
      { label: 'Action', hide: true, key: 'moduleAction', show: true }
    ]
  },
  periodicalReport: {
    skip: 0,
    rowsPerPage: 50,
    columnsTable: [
      { label: 'Code', hide: true, key: 'code', show: true },
      { label: 'Name', hide: true, key: 'name', show: true },
      { label: 'Year', hide: true, key: 'year', show: true },
      { label: 'Period', hide: true, key: 'period', show: true },
      {
        label: 'Status',
        hide: true,
        key: 'status',
        show: true,
        className: 'uppercase'
      }
    ]
  },
  assessmentTemplates: {
    skip: 0,
    rowsPerPage,
    columnsTable: [
      { label: 'Name', key: 'name', hide: true, show: true, sort: true },
      {
        label: 'Year Level',
        key: 'yearLevel',
        show: true,
        hide: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'Number of Questions',
        key: 'questions',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Log',
        key: 'log',
        align: 'center',
        className: 'text-center box-center',
        hide: true,
        show: true
      }
    ]
  },
  surveyTemplates: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      { label: 'Name', key: 'name', show: true, sort: true },
      {
        label: 'Role',
        key: 'role',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'Number of Questions',
        key: 'questions',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Log',
        key: 'log',
        align: 'center',
        className: 'text-center box-center',
        hide: true,
        show: true
      }
    ]
  },
  importTemplates: {
    skip: 0,
    rowsPerPage: 25,
    columnsTable: [
      { label: 'Name', key: 'name', hide: true, show: true, sort: true },
      {
        label: 'Number of Questions',
        key: 'questions',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Template Type',
        key: 'type',
        hide: true,
        show: true,
        sort: true
      },
      { label: 'Message', key: 'message', hide: true, show: true, sort: true }
    ]
  },
  surveyList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      { label: 'Name', key: 'name', hide: true, show: true, sort: true },
      {
        label: 'Template',
        key: 'template',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'type',
        key: 'type',
        hide: true,
        show: true
      },
      {
        label: 'Completed',
        key: 'completed',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        sort: true
      },
      {
        label: 'Note',
        key: 'note',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      { label: 'Due Date', key: 'date', hide: true, show: true },
      {
        label: 'Status',
        key: 'status',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom',
        align: 'center'
      },
      {
        label: 'Log',
        key: 'log',
        align: 'center',
        className: 'text-center box-center',
        hide: true,
        show: true
      }
    ]
  },
  mySurveysList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      { label: 'Name', key: 'name', hide: true, show: true, sort: true },
      {
        label: 'Created By',
        key: 'creator',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Number of Questions',
        key: 'questions',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Status',
        key: 'status',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom',
        align: 'center'
      },
      { label: 'Assigned Date', key: 'assignedDate', hide: true, show: true },
      {
        label: 'Date Filled Out',
        key: 'dateFilledOut',
        hide: true,
        show: true
      },
      { label: 'Due Date', key: 'date', hide: true, show: true },
      { label: 'Notes', key: 'note', hide: true, show: true }
    ]
  },
  aboutMeSurverList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      {
        label: 'Name',
        key: 'name',
        align: 'left',
        width: 150,
        show: true,
        hide: false
      },
      {
        label: 'Created By',
        key: 'creator',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Number of Questions',
        width: 100,
        key: 'questions',
        align: 'center',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Completed',
        key: 'completed',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        sort: true
      },
      {
        label: 'Status',
        key: 'status',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      { label: 'Due Date', key: 'date', hide: true, show: true }
    ]
  },
  aboutMyClassesSurverList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      {
        label: 'Name',
        key: 'name',
        align: 'left',
        width: 160,
        show: true,
        hide: false
      },
      {
        label: 'Created By',
        key: 'creator',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Number of Questions',
        width: 100,
        key: 'questions',
        align: 'center',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'Completed',
        key: 'completed',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        sort: true
      },
      {
        label: 'Status',
        key: 'status',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      { label: 'Due Date', key: 'date', hide: true, show: true }
    ]
  },
  surveyUsersList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      {
        label: 'Photo',
        key: 'avatar',
        align: 'center',
        hide: true,
        show: true
      },
      {
        label: 'Code',
        key: 'code',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Name',
        key: 'name',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Email',
        key: 'email',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Roles',
        key: 'roles',
        hide: true,
        show: true,
        delete: true,
        filter: 'roles',
        sort: true,
        sortKey: 'rolesSort'
      },
      {
        label: 'Year Level',
        key: 'yearLevelUser',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom',
        sort: true,
        sortKey: 'yearLevelUserSort'
      }
    ]
  },
  surveyClassList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      {
        label: 'Code',
        key: 'code',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Year Level',
        key: 'yearLevel',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom',
        sort: true,
        sortKey: 'yearLevelUserSort'
        //sortKey: 'rolesSort'
      },
      {
        label: 'Teachers',
        key: 'teachers',
        hide: true,
        show: true
      }
    ]
  },
  surveyPreviewList: {
    rowsPerPage,
    skip: 0,
    columnsTable: [
      {
        label: 'Photo',
        key: 'avatar',
        align: 'center',
        className: 'text-center box-center',
        hide: true,
        show: true
      },
      {
        label: 'Code',
        key: 'code',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Name',
        key: 'name',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Role',
        key: 'roles',
        hide: true,
        show: true,
        delete: true,
        filter: 'roles',
        sort: true,
        sortKey: 'rolesSort'
      },
      {
        label: 'Year Level',
        key: 'yearLevelUser',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom',
        sort: true,
        sortKey: 'yearLevelUserSort'
      },
      {
        label: 'Status',
        key: 'status',
        hide: true,
        show: true,
        delete: true,
        align: 'center',
        filter: 'custom',
        sort: true,
        sortKey: 'statusSort'
      }
    ]
  },
  assessmentList: {
    skip: 0,
    rowsPerPage,
    columnsTable: [
      { label: 'Name', key: 'name', hide: true, show: true, sort: true },
      {
        label: 'Template',
        key: 'template',
        hide: true,
        show: true,
        sort: true
      },
      {
        label: 'type',
        key: 'type',
        hide: true,
        show: true
      },
      {
        label: 'Year Level',
        key: 'yearLevel',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'Class',
        key: 'class',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      { label: 'Sitting date', key: 'sittingDate', hide: true, show: true },
      { label: 'Due date', key: 'dueDate', hide: true, show: true },
      { label: 'Status', key: 'status', hide: true, show: true, align: 'center' },
      // { label: "Date", key: "date", hide: true, show: true },
      {
        label: 'Note',
        key: 'note',
        align: 'center',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'Log',
        key: 'log',
        align: 'center',
        className: 'text-center box-center',
        hide: true,
        show: true
      }
    ]
  },
  assessmentStudentsList: {
    skip: 0,
    rowsPerPage,
    columnsTable: [
      {
        label: 'Photo',
        key: 'avatar',
        align: 'center',
        width: 50,
        hide: true,
        show: true,
        delete: true
      },
      {
        label: 'Code',
        key: 'code',
        width: 80,
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Name',
        width: 180,
        key: 'name',
        hide: true,
        show: true,
        delete: true,
        filter: 'text',
        sort: true
      },
      {
        label: 'Year Level',
        width: 80,
        key: 'yearLevelUser',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      },
      {
        label: 'flags',
        width: 80,
        key: 'flags',
        hide: true,
        show: true,
        delete: true
      },
      {
        label: 'house',
        width: 80,
        key: 'house',
        hide: true,
        show: true,
        delete: true
      },
      {
        label: 'form',
        width: 80,
        key: 'form',
        hide: true,
        show: true,
        delete: true
      },
      {
        label: 'Classes',
        key: 'class',
        hide: true,
        show: true,
        delete: true,
        filter: 'custom'
      }
    ]
  },
  assessmentMarking: {
    rowsPerPage: 100,
    skip: 0,
    columnsTable: []
  },
  feed: {
    skip: 0,
    rowsPerPage: 25,
    columnsTable: [
      { label: 'title', key: 'title', hide: true, show: true, sort: true },
      { label: 'post type', key: 'postType', hide: true, show: true, sort: true },
      { label: 'view roles', key: 'viewRoles', hide: true, show: true, sort: true },
      { label: 'view years', key: 'viewYearLevels', hide: true, show: true, sort: true },
      { label: 'published at', key: 'pusblishedAt', hide: true, show: true, sort: true },
      { label: 'expire at', key: 'expireAt', hide: true, show: true, sort: true },
      { label: 'status', key: 'status', hide: true, show: true, sort: true, className: 'text-center' }
    ]
  }
}

const datatableReducer = (state = initState, action) => {
  const newState = { ...state }
  const { payload } = action
  switch (action.type) {
    case DATATABLE_UPDATE_COLUMNS_TABLE:
      if (newState[payload.module]) {
        newState[payload.module].columnsTable = [...payload.list]
      }
      break
    case DATATABLE_UPDATE_COLUMNS_TABLE_CURRICULUM: {
      const listData = JSON.parse(JSON.stringify(payload.list || []))
      const module = payload.module
      const curriculumId = payload.curriculumId

      // Crea una copia profunda del estado actual
      const newStateCopy = JSON.parse(JSON.stringify(newState || {}))
      newStateCopy[module][curriculumId] = [...listData]

      // if (payload.firstTime) {
      //   const oldColumns = newStateCopy?.[module]?.[curriculumId] || [];
      //   const newColumns = listData?.map((column) => {
      //     const oldColumn = oldColumns.find((old) => old.key === column.key);
      //     return oldColumn ? { ...column, ...oldColumn } : column;
      //   });
      //   newStateCopy[module][curriculumId] = [...newColumns];
      // } else {
      //   newStateCopy[module][curriculumId] = [...listData];
      // }

      // Actualiza el estado con la copia modificada
      return newStateCopy
    }
    case DATATABLE_UPDATE_SKIP:
      if (newState[payload.module]) {
        newState[payload.module].skip = payload.skip
      }
      break
    case DATATABLE_UPDATE_ROWS_PER_PAGE:
      if (newState[payload.module]) {
        newState[payload.module].rowsPerPage = payload.length
      }
      break
    default:
      break
  }

  return newState
}

export default datatableReducer
